import { fetchApi } from '@/services/api-client';

export const ATTENDANCE_AWARDS_PATH = '/admin/attendance-awards';

export type AutoAwardRuleKey = 'attendance_weekly' | 'attendance_monthly';

export type AutoAwardRule = {
  ruleKey: AutoAwardRuleKey;
  enabled: boolean;
  categoryId: string | null;
  categoryName: string | null;
  minSchoolDays: number;
};

export type UpdateAutoAwardRuleBody = {
  enabled: boolean;
  categoryId: string | null;
  minSchoolDays: number;
};

export type AutoAwardRunResult = {
  rule: AutoAwardRuleKey;
  periodKey: string;
  schoolDays: number;
  awarded: number;
  skipped: 'disabled' | 'no-category' | 'too-few-school-days' | 'year-not-writable' | null;
};

export const attendanceAwardsApi = {
  listRules: () => fetchApi<{ rules: AutoAwardRule[] }>(`${ATTENDANCE_AWARDS_PATH}/rules`),
  updateRule: (ruleKey: AutoAwardRuleKey, body: UpdateAutoAwardRuleBody) =>
    fetchApi<AutoAwardRule>(`${ATTENDANCE_AWARDS_PATH}/rules/${ruleKey}`, {
      method: 'PUT',
      body: JSON.stringify(body),
    }),
  run: (body: { ruleKey: AutoAwardRuleKey; date: string }) =>
    fetchApi<AutoAwardRunResult>(`${ATTENDANCE_AWARDS_PATH}/run`, { method: 'POST', body: JSON.stringify(body) }),
};
